import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import CADDashboard from './pages/CADDashboard';
import RecordsDashboard from './pages/RecordsDashboard';
import JobDetail from './pages/JobDetail';
import MapView from './pages/MapView';
import LeavePage from './pages/LeavePage';
import GISDashboard from './pages/GISDashboard';
import AdminPage from './pages/AdminPage';
import StatsPage from './pages/StatsPage';
import DigsDashboard from './pages/DigsDashboard';
import BreakRoom from './pages/BreakRoom';
import PendingPage from './pages/PendingPage';
import QCPage from './pages/QCPage';
import DirectoryPage from './pages/DirectoryPage';
import ToolsPage from './pages/ToolsPage';
import Contacts811 from './pages/Contacts811';
import TicketFinder from './pages/TicketFinder';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'pending') return <Navigate to="/pending" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'pending') return <Navigate to="/pending" replace />;
  if (user.role === 'records') return <Navigate to="/records" replace />;
  if (user.role === 'upload') return <Navigate to="/dashboard" replace />;
  if (user.role === 'gis') return <Navigate to="/gis" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/pending" element={<PendingPage />} />
          <Route path="/" element={<RootRedirect />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute roles={['cad', 'admin', 'upload']}>
                <CADDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/records"
            element={
              <PrivateRoute roles={['records', 'admin', 'upload']}>
                <RecordsDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/job/:projectId"
            element={
              <PrivateRoute>
                <JobDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/directory"
            element={
              <PrivateRoute>
                <DirectoryPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/map"
            element={
              <PrivateRoute>
                <MapView />
              </PrivateRoute>
            }
          />
          <Route
            path="/leave"
            element={
              <PrivateRoute>
                <LeavePage />
              </PrivateRoute>
            }
          />
          {/* Old bookmark — the Convert page became one tab of the Tools page */}
          <Route path="/convert" element={<Navigate to="/tools" replace />} />
          <Route
            path="/tools"
            element={
              <PrivateRoute roles={['gis', 'cad', 'admin', 'upload']}>
                <ToolsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/gis"
            element={
              <PrivateRoute roles={['gis', 'admin']}>
                <GISDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute roles={['admin']}>
                <AdminPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/stats"
            element={
              <PrivateRoute roles={['cad', 'records', 'admin']}>
                <StatsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <PrivateRoute roles={['records', 'admin', 'upload']}>
                <Contacts811 />
              </PrivateRoute>
            }
          />
          <Route
            path="/tickets"
            element={
              <PrivateRoute roles={['admin', 'upload']}>
                <TicketFinder />
              </PrivateRoute>
            }
          />
          <Route
            path="/digs"
            element={
              <PrivateRoute roles={['records', 'admin', 'upload']}>
                <DigsDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/break-room"
            element={
              <PrivateRoute>
                <BreakRoom />
              </PrivateRoute>
            }
          />
          <Route
            path="/qc"
            element={
              <PrivateRoute roles={['cad', 'admin']}>
                <QCPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
